import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { createClassAbility } from "./ability";
import { AbilityContext } from "./can";

const deniedAbility = {
  can: () => false,
  cannot: () => true,
  rules: []
};

const withClassAbility = WrappedComponent => {
  const ComponentWithClassAbility = props => {
    const campusAbility = useContext(AbilityContext);
    const [ability, setAbility] = useState(null);
    const { match } = props;
    const classId =
      match?.params?.id || window.localStorage.getItem("class");

    useEffect(() => {
      let mounted = true;

      createClassAbility(classId, campusAbility)
        .then(classAbility => {
          if (mounted) setAbility(classAbility || deniedAbility);
        })
        .catch(() => {
          if (mounted) setAbility(deniedAbility);
        });

      return () => {
        mounted = false;
      };
    }, [classId, campusAbility]);

    if (!ability) return null;

    return (
      <AbilityContext.Provider value={ability}>
        <WrappedComponent {...props} />
      </AbilityContext.Provider>
    );
  };

  ComponentWithClassAbility.propTypes = {
    match: PropTypes.shape({
      params: PropTypes.shape({
        id: PropTypes.string
      })
    }).isRequired
  };

  return ComponentWithClassAbility;
};

export default withClassAbility;
